var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimorLeste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1604)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C31.0459 40 40.0003 31.0457 40.0003 20C40.0003 8.9543 31.0459 0 20.0002 0C8.95455 0 0.000244141 8.9543 0.000244141 20C0.000244141 31.0457 8.95455 40 20.0002 40Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 20C0.000244141 8.95437 8.95462 0 20.0002 0C31.0459 0 40.0003 8.95437 40.0003 20",
    fill: "#338AF3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V40H0V0Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20L0 40V0L40 20Z",
    fill: "#FFC72C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 20L0 40V0L26.6667 20Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18129 13.9082L14.6602 23.3373L2.25818 20.6926L13.846 15.5426L7.4984 26.5202L6.18129 13.9082Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimorLeste);
export default __webpack_public_path__ + "static/media/timor_leste.e771f0d05b59b46c9c2fa38f62239556.svg";
export { ForwardRef as ReactComponent };